import { apiFetch, ApiError } from '../../lib/api';
import { DRIP_DASHBOARD_FIXTURE } from './fixtures';
import type { DripDashboardSnapshot } from './types';

export type DripDataMode = 'live' | 'demo';

export type FetchDripDashboardResult =
  | { ok: true; snapshot: DripDashboardSnapshot; mode: DripDataMode; demoReason?: string }
  | { ok: false; message: string };

/**
 * Loads dashboard data. Demo snapshot is used when `VITE_DRIP_USE_FIXTURES=true`
 * or when the API returns 501 (endpoint not implemented).
 */
export async function fetchDripDashboard(token: string): Promise<FetchDripDashboardResult> {
  if (import.meta.env.VITE_DRIP_USE_FIXTURES === 'true') {
    return {
      ok: true,
      snapshot: DRIP_DASHBOARD_FIXTURE,
      mode: 'demo',
      demoReason: 'fixtures_env',
    };
  }

  try {
    const snapshot = await apiFetch<DripDashboardSnapshot>('/api/staff/drip-campaigns/dashboard', { token });
    return { ok: true, snapshot, mode: 'live' };
  } catch (e) {
    if (e instanceof ApiError && e.status === 501) {
      return {
        ok: true,
        snapshot: DRIP_DASHBOARD_FIXTURE,
        mode: 'demo',
        demoReason: 'api_501',
      };
    }
    return { ok: false, message: e instanceof Error ? e.message : 'Could not load drip dashboard.' };
  }
}
